import { IAccordionHeader, ITableDataRow } from '../../types';
import { getFormula } from '../../utils';

interface IProps {
  headers: IAccordionHeader[] | undefined;
}

export const getSalaryTable = (props: IProps) => {
  const { headers = [] } = props;
  const datas = [];
  const rows: ITableDataRow[] = [];
  const sf = getFormula('SALARYTAKE_FORMULA', {
    ...props,
  });
  const rows1 = [
    {
      value: 'Performance Bonus',
      className: 'bg-white',
    },
    {
      value: '-',
      className: 'bg-white',
    },
    {
      value: '₹' + Math.abs(sf.performance).toFixed(0),
      className: 'bg-white',
    },
  ];
  rows.push({
    data: rows1,
  });
  const rows2 = [
    {
      value: 'Total Gross Pay',
      className: 'bg-white',
    },
    {
      value: '₹' + Math.round(sf.grossMonthly).toFixed(0),
      className: 'bg-white',
    },
    {
      value: '₹' + Math.round(sf.grossYearly).toFixed(0),
      className: 'bg-white',
    },
  ];
  rows.push({
    data: rows2,
  });
  datas.push({
    type: 'table',
    title: '',
    data: [
      {
        headers: headers,
        rows: rows,
      },
    ],
  });

  return datas;
};
